var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiperBox",style:({ position: 'relative', height: _vm.styles.height + 'px' })},[_c('div',{staticClass:"swiper-container",style:({
      width: _vm.styles.width + 'px',
      position: 'absolute',
      height: _vm.styles.height + 'px',
      left: '50%',
      marginLeft: '-960px'
    })},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.sliderData),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide"},[_c('img',{attrs:{"src":item.FileUrl}})])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a111c5c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider.vue
// module id = null
// module chunks = 